var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseSmallAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 38,
    rx: 19,
    fill: "url(#paint0_linear_3637_11207)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7258 25.4516L16.375 17.6836V10.125H14.8125V8.5625H24.1875V10.125H22.625V17.6836L28.2742 25.4516C28.615 25.9199 28.8195 26.4733 28.8652 27.0507C28.9109 27.6281 28.796 28.2068 28.5332 28.7229C28.2704 29.239 27.8699 29.6723 27.376 29.975C26.8822 30.2776 26.3143 30.4376 25.7351 30.4375H13.2656C12.6864 30.4376 12.1185 30.2776 11.6247 29.975C11.1309 29.6723 10.7304 29.239 10.4676 28.7229C10.2047 28.2068 10.0898 27.6281 10.1355 27.0507C10.1812 26.4733 10.3858 25.9199 10.7265 25.4516H10.7258ZM21.0625 18.1914V10.125H17.9375V18.1914L15.8492 21.0625H23.1508L21.0625 18.1914ZM13.2648 28.875H25.7344C26.0251 28.8747 26.3102 28.794 26.558 28.6419C26.8059 28.4899 27.0069 28.2723 27.1389 28.0131C27.2708 27.754 27.3287 27.4635 27.306 27.1736C27.2832 26.8837 27.1809 26.6057 27.0101 26.3703L24.2867 22.625H14.7133L11.989 26.3703C11.8183 26.6057 11.7159 26.8837 11.6932 27.1736C11.6705 27.4635 11.7283 27.754 11.8603 28.0131C11.9923 28.2723 12.1933 28.4899 12.4411 28.6419C12.689 28.794 12.974 28.8747 13.2648 28.875Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3637_11207",
    x1: 0.5,
    y1: 0.5,
    x2: 38.5,
    y2: 38.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseSmallAvatar);
export default __webpack_public_path__ + "static/media/courseSmallAvatar.cd12d7c6fcfcb7b6b28c79d47a906ae0.svg";
export { ForwardRef as ReactComponent };